import { React, useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import PortalComponents from '../../components/PortalComponents/PortalComponents';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import DropFileInputArray from '../../components/DragAndDrop/components/drop-file-input/DropFileInputArray';
import FormComponent from '../../components/FormComponents/FormComponent';
import loading from '../../Images/three-dots.svg'
import DropChange from '../../components/DragAndDrop/components/drop-file-input/DropChange';
const areArraysIdentical = (array1, array2) => {
    // Check if arrays have the same length
    if (array1.length !== array2.length) {
        return false;
    }

    // Sort both arrays
    const sortedArray1 = array1.slice().sort();
    const sortedArray2 = array2.slice().sort();

    // Compare each element in the sorted arrays
    for (let i = 0; i < sortedArray1.length; i++) {
        if (sortedArray1[i] !== sortedArray2[i]) {
            return false;
        }
    }

    // If all elements are identical, return true
    return true;
};
const Guardian = ({ formik, setSelectedService, CheckProofDocRequired, selectedData, req_count, alerationReq, policy_number, isReqLoading }) => {
    
    const [fileList, setFileList] = useState([])
    const [requestEnable, setRequestEnable] = useState(false);
    useEffect(() => {
        if(selectedData?.gardian && formik.values.gardian){
            setRequestEnable(!areArraysIdentical(selectedData.gardian, formik.values.gardian))
        }
       
    },[formik.values.gardian])
    function RemoveProofDocInInitial(type, index) {

        if (!(selectedData.gardian.length >= index + 1 && selectedData.gardian && selectedData.gardian[index] && formik.values.gardian && formik.values.gardian[index] && selectedData.gardian[index][type] != formik.values.gardian[index][type])) {

            const proof_docs = formik.values.gardian && formik.values.gardian[index] && formik.values.gardian[index].proof_doc;

            if (proof_docs) {
                const hasType = proof_docs.some(item => item.name === type);

                if (hasType) {

                    const filteredProofDocs = proof_docs.filter(item => item.name !== type);


                    formik.setFieldValue(`gardian[${index}].proof_doc`, filteredProofDocs);
                }
            }

        }
    }
    return (
        <>
            <Row className='justify-content-start d-flex' style={{ width: "100%" }}>

                <Col xs={1} className='my-3 justify-content-start d-flex'>
                    <motion.div
                        whileTap={{
                            scale: 0.9
                        }}
                        onClick={() => {
                            setSelectedService(0)
                            formik.setFieldValue('gardian', selectedData.gardian);
                        }}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </motion.div>
                </Col>


            </Row>
            <Row style={{ width: "100%" }} className='d-flex justify-content-center'>
            <h1 style={{fontSize:"20px", fontWeight:"bold" ,textAlign:"center"}}>GARDIAN</h1>
            </Row>
            {
                selectedData?.gardian && formik.values ? (
                    formik.values.gardian?.map((value, index) => {


                        return (
                            <Row style={{ width: "100%",margin:0 }} key={`gardian${index}`}>


                                <Col xs={12} className='pt-5  mt-5 nominee-con' >
                                    {selectedData.gardian.length < index + 1 ?
                                        <Row className='mb-1'>
                                            <Col xs={12} className='d-flex justify-content-end'>
                                                <Button isIconOnly={true} style={{ scale: "0.5" }}><FontAwesomeIcon icon={faCircleXmark} onClick={(indexToRemove) => {
                                                    const updatedgardian = [...formik.values.gardian];
                                                    updatedgardian.splice(index, 1);
                                                    formik.setFieldValue('gardian', updatedgardian);
                                                    const filterdList = fileList.filter(item => item.index !== index);
                                                    const newFiles = filterdList.map(item => ({
                                                        ...item,
                                                        index: item.index > index ? item.index - 1 : item.index
                                                    }));
                                                    setFileList(newFiles)
                                                }} style={{ height: "100%" }} /></Button>
                                            </Col>
                                        </Row>
                                        :
                                        null
                                    }
                                    <Row>
                                        <Col xs={6}>
                                            <PortalComponents
                                                type={"input-name"}
                                                label={"Full Name"}
                                                name={`gardian[${index}].name`}
                                                formik={formik}
                                                value={formik.values.gardian?.[index]?.name}
                                                onchange={formik.handleChange}
                                                errors={formik.errors.gardian?.[index]?.name}

                                            />
                                       
                                            {CheckProofDocRequired("gardian", "name", index)}
                                            {RemoveProofDocInInitial("name", index)}
                                            {selectedData.gardian.length >= index + 1 && selectedData.gardian && selectedData.gardian[index] && formik.values.gardian && formik.values.gardian[index] && selectedData.gardian[index].name != formik.values.gardian[index].name ?

                                                <Col xs={12} className='d-flex justify-content-center'>

                                                    <DropChange  values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.gardian?.proof_doc && formik.errors.gardian?.proof_doc[index]?.name} nameofFile={"name"} table={"gardian"} />
                                                </Col> :
                                                null
                                            }

                                        </Col>
                                        <Col xs={6}>
                                            <Row>
                                                <Col xs={12}>
                                                    <div className='m-3'> <FormComponent
                                                        type={"date-picker"}
                                                        label={"Birthday"}
                                                        value={formik.values.gardian?.[index]?.birthday}
                                                        name={`gardian[${index}].birthday`}
                                                        setFieldValue={formik.setFieldValue}
                                                        errors={formik.errors.gardian?.[index]?.birthday}

                                                    /></div>

                                                </Col>
                                                <Col xs={12}>

                                                    {CheckProofDocRequired("gardian", "birthday", index)}
                                                    {RemoveProofDocInInitial("birthday", index)}

                                                    {selectedData.gardian.length >= index + 1 && selectedData.gardian && selectedData.gardian[index] && formik.values.gardian && formik.values.gardian[index] && selectedData.gardian[index].birthday != formik.values.gardian[index].birthday ?

                                                        <Col xs={12} className='d-flex justify-content-center'>


                                                            <DropChange fileList={fileList} setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.gardian?.proof_doc && formik.errors.gardian?.proof_doc[index]?.birthday} nameofFile={"birthday"} table={"gardian"} />
                                                        </Col> :
                                                        null
                                                    }

                                                </Col>
                                            </Row>


                                        </Col>

                                    </Row>
                                    <Row className='my-0' >

                                        <Col xs={6}>

                                            <PortalComponents
                                                type={"input-nic"}
                                                label={"NIC"}
                                                name={`gardian[${index}].nic`}
                                                formik={formik}
                                                value={formik.values.gardian?.[index]?.nic}
                                                onchange={formik.handleChange}
                                                errors={formik.errors.gardian?.[index]?.nic}


                                            />
                                            {CheckProofDocRequired("gardian", "nic", index)}
                                            {RemoveProofDocInInitial("nic", index)}

                                            {selectedData.gardian.length >= index + 1 && selectedData.gardian && selectedData.gardian[index] && formik.values.gardian && formik.values.gardian[index] && selectedData.gardian[index].nic != formik.values.gardian[index].nic ?

                                                <Col xs={12} className='d-flex justify-content-center'>

                                                    <DropChange fileList={fileList} setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.gardian?.proof_doc && formik.errors.gardian?.proof_doc[index]?.nic} nameofFile={"nic"} table={"gardian"} />
                                                </Col> :
                                                null
                                            }
                                        </Col>
                                        <Col xs={6}>
                                            <Row>
                                                <Col xs={12}>
                                                    {/* <PortalComponents
                                                        type={"input-name"}
                                                        label={"Relationship"}
                                                        name={`gardian[${index}].relationship`}
                                                        formik={formik}
                                                        value={formik.values.gardian?.[index]?.relationship}
                                                        onchange={formik.handleChange}
                                                        errors={formik.errors.gardian?.[index]?.relationship}


                                                    /> */}


                                                    <PortalComponents
                                                        type={"input-relationship"}
                                                        label={"Relationship"}
                                                        name={`gardian[${index}].relationship`}
                                                        formik={formik}
                                                        value={formik.values.gardian?.[index]?.relationship}
                                                        onchange={formik.handleChange}
                                                        errors={formik.errors.gardian?.[index]?.relationship}


                                                    />


                                                </Col>
                                                <Col xs={12}>

                                                    {CheckProofDocRequired("gardian", "relationship", index)}
                                                    {RemoveProofDocInInitial("relationship", index)}

                                                    {selectedData.gardian.length >= index + 1 && selectedData.gardian && selectedData.gardian[index] && formik.values.gardian && formik.values.gardian[index] && selectedData.gardian[index].relationship != formik.values.gardian[index].relationship ?

                                                        <Col xs={12} className='d-flex justify-content-center'>


                                                            <DropChange fileList={fileList} setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.gardian?.proof_doc && formik.errors.gardian?.proof_doc[index]?.relationship} nameofFile={"relationship"} table={"gardian"} />
                                                        </Col> :
                                                        null
                                                    }

                                                </Col>
                                            </Row>


                                        </Col>

                                        <Col xs={6} className='d-flex justify-content-center'>

                                        <PortalComponents
                                            type={"input"}
                                            label={"Proof Description - Please describe what you requested.."}
                                            formik={formik}
                                            name={`gardian[${index}].proof_description`}
                                            value={formik.values.gardian?.[index]?.proof_description}
                                            onchange={formik.handleChange}
                                            errors={formik.errors.gardian?.[index]?.proof_description}                                           

                                        />                                           

                                        </Col>


                                        {selectedData.gardian.length < index + 1 ?

                                            <Col xs={12} className='d-flex justify-content-center'>


                                                <DropFileInputArray  fileList={fileList} setFileList={setFileList} values={formik.values} index={index} CheckProofDocRequired={CheckProofDocRequired} setFieldValue={formik.setFieldValue} error={formik.errors.gardian?.proof_doc && formik.errors.gardian?.proof_doc[index]?.new} nameofFile={"new"} table={"gardian"} />
                                            </Col> :
                                            null
                                        }
                                    </Row>
                                    <Row>

                                    </Row>

                                </Col>





                            </Row>

                        )


                    }

                    )
                ) : (
                    <Row>
                        <img src={loading} className='m-5' style={{ width: "40%" }} />
                    </Row>
                )
            }
{ selectedData?.gardian && formik.values&&formik.values.gardian&&formik.values.gardian.length==0&&
            <div className='no-result-con p-5 d-flex justify-content-center align-items-center my-5'>
                <div className='d-flex flex-row align-items-center'>
                <FontAwesomeIcon icon={ faTimesCircle} style={{scale:"1.5"}}/> <div className='mx-3'>No Gardian  </div>
                </div>

            </div>

            }


            <Row style={{ width: "100%" ,margin:0}} className='d-flex justify-content-end'>
                <Col lg={3} md={3} sm={12} xs={12} className='my-4  d-flex justify-content-end '>
                    <Button
                        onClick={() => formik.setFieldValue('gardian', [...formik.values.gardian, { name: '', nic: '', mobile: '', email: '', proof_doc: [] }])}
                        color='success' variant="solid"
                        style={{ color: "white" }}
                    >
                        Add Gardian
                    </Button>
                </Col>
            </Row>
           {requestEnable&& <Row style={{ width: "100%" }} className='d-flex justify-content-center'>
                <Col xs={3} className='my-4 '>

                    {req_count && req_count > 0 ?
                        <Button
                            onClick={() => { alerationReq("guardian add", "gardian", policy_number) }}
                            color='warning' variant="solid"
                            style={{ color: "white" }}
                            isDisabled
                        >
                            Request Pending
                        </Button> :
                        <Button
                            onClick={() => { alerationReq("guardian add", "gardian", policy_number) }}
                            color='primary' variant="solid"
                            style={{ color: "white" }}
                            isLoading={isReqLoading}
                        >
                            Request Change
                        </Button>
                    }




                </Col>
            </Row>}
        </>
    )
}

export default Guardian
